import { collection, doc, getDoc, getDocs, orderBy, query } from 'firebase/firestore';
import {
  firebaseAuth,
  firebaseFire as Libfirebase,
  firebaseStorage
} from '../helpers/firebase-config.js';
import { firebaseDb } from '../helpers/firebase-config2.js';
import { removeAcentos } from '../helpers/utils.js';

export const ufs = [
  { "nome": "Acre", "sigla": "AC" },
  { "nome": "Alagoas", "sigla": "AL" },
  { "nome": "Amapá", "sigla": "AP" },
  { "nome": "Amazonas", "sigla": "AM" },
  { "nome": "Bahia", "sigla": "BA" },
  { "nome": "Ceará", "sigla": "CE" },
  { "nome": "Distrito Federal", "sigla": "DF" },
  { "nome": "Espírito Santo", "sigla": "ES" },
  { "nome": "Goiás", "sigla": "GO" },
  { "nome": "Maranhão", "sigla": "MA" },
  { "nome": "Mato Grosso", "sigla": "MT" },
  { "nome": "Mato Grosso do Sul", "sigla": "MS" },
  { "nome": "Minas Gerais", "sigla": "MG" },
  { "nome": "Pará", "sigla": "PA" },
  { "nome": "Paraíba", "sigla": "PB" },
  { "nome": "Paraná", "sigla": "PR" },
  { "nome": "Pernambuco", "sigla": "PE" },
  { "nome": "Piauí", "sigla": "PI" },
  { "nome": "Rio de Janeiro", "sigla": "RJ" },
  { "nome": "Rio Grande do Norte", "sigla": "RN" },
  { "nome": "Rio Grande do Sul", "sigla": "RS" },
  { "nome": "Rondônia", "sigla": "RO" },
  { "nome": "Roraima", "sigla": "RR" },
  { "nome": "Santa Catarina", "sigla": "SC" },
  { "nome": "São Paulo", "sigla": "SP" },
  { "nome": "Sergipe", "sigla": "SE" },
  { "nome": "Tocantins", "sigla": "TO" }
];


export function setCidade(data) {
  return new Promise(function (resolve, reject) {
    if (data.id) {
      Libfirebase.collection('cidade')
        .doc(data.id)
        .update(data)
        .then(() => resolve(true))
        .catch(error => {
          const erro = {
            error,
            msg: 'Houve um problema ao editar a cidade, favor tentar novamente',
            obj: data
          };
          reject(erro);
        });
    } else {
      Libfirebase.collection('cidade')
        .add(data)
        .then(() => resolve(true))
        .catch(error => {
          const erro = {
            error,
            msg: 'Houve um problema ao cadastrar a cidade, favor tentar novamente',
            obj: data
          };
          reject(erro);
        });
    }
  });
}

export function getCidade(idcidade = null) {
  return new Promise(function (resolve, reject) {
    let ref = Libfirebase.collection('cidade');
    if (idcidade) {
      ref = ref
        .doc(idcidade)
        .get()
        .then(doc => {
          const data = {
            id: doc.id,
            cidade: doc.data().Cidade,
            ativo: doc.data().Ativo,
            ibge: doc.data().ibge,
            uf: doc.data().uf
          };

          resolve(data);
        })
        .catch(error => {
          const erro = {
            error,
            msg: error.code
          };
          reject(erro);
        });
    } else {
      let list = [];
      ref
        .orderBy('Cidade')
        .get()
        .then(snap => {
          snap.forEach(doc => {
            const data = {
              id: doc.id,
              cidade: doc.data().Cidade,
              ativo: doc.data().Ativo,
              ibge: doc.data().ibge,
              uf: doc.data().uf,
              desativadaEm: doc.data().desativadaEm
            };

            list.push(data);
          });
          resolve(list);
        })
        .catch(error => {
          const erro = {
            error,
            msg: error.code
          };

          reject(erro);
        });
    }
  });
}

export function getCidadeNew(idcidade = null) {
  return new Promise(async function (resolve, reject) {

    if (idcidade) {
      const docRef = doc(firebaseDb, "cidade", idcidade);
      const docSnap = await getDoc(docRef);
      if (docSnap.exists()) {
        const data = {
          id: docSnap.id,
          cidade: docSnap.data().Cidade,
          ativo: docSnap.data().Ativo,
          ibge: docSnap.data().ibge,
          uf: docSnap.data().uf
        };

        resolve(data);
      }

      reject("Cidade não existe");

    } else {
      console.log("cidades ------------")
      let list = [];
      const ref = collection(firebaseDb, 'cidade')
      const q = query(ref, orderBy("Cidade"));

      getDocs(q)
        .then(snap => {
          console.log("cidades ------------")
          snap.forEach(doc => {
            const data = {
              id: doc.id,
              cidade: doc.data().Cidade,
              ativo: doc.data().Ativo,
              ibge: doc.data().ibge,
              uf: doc.data().uf,
              desativadaEm: doc.data().desativadaEm
            };

            list.push(data);
          });
          resolve(list);
        })
        .catch(error => {
          const erro = {
            error,
            msg: error.code
          };

          reject(erro);
        });
    }
  });
}

export function updateCidade(id, data) {
  return new Promise(function (resolve, reject) {
    Libfirebase.collection('cidade')
      .doc(id)
      .update(data)
      .then(() => resolve(true))
      .catch(error => {
        const erro = {
          error,
          msg: error.code
        };
        reject(erro);
      });
  });
}

export function getCidadebyId(idcidade) {
  return new Promise(function (resolve, reject) {
    let ref = Libfirebase.collection('cidade');

    if (idcidade) {
      ref = ref
        .doc(idcidade)
        .get()
        .then(doc => {
          const data = {
            id: doc.id,
            cidade: doc.data().Cidade,
            ativo: doc.data().Ativo,
            ibge: doc.data().ibge,
            uf: doc.data().uf

          };

          resolve(data);
        })
        .catch(error => {
          const erro = {
            error,
            msg: error.code
          };
          reject(erro);
        });
    } else {
      let list = [];
      ref
        .get()
        .then(snap => {
          snap.forEach(doc => {
            const data = {
              id: doc.id,
              cidade: doc.data().Cidade,
              ativo: doc.data().Ativo,
              desativadaEm: doc.data().desativadaEm,
              uf: doc.data().uf

            };

            list.push(data);
          });
          resolve(list);
        })
        .catch(error => {
          const erro = {
            error,
            msg: error.code
          };

          reject(erro);
        });
    }
  });
}

export function getCidadeByName(cidadeName) {
  return new Promise(function (resolve, reject) {
    Libfirebase.collection('cidade')
      .where('Cidade', '==', cidadeName)
      .where('Ativo', '==', true)
      .get()
      .then(async (snapShot) => {
        snapShot.forEach(async (doc) => {
          const data = {
            id: doc.id,
            cidade: doc.data().Cidade,
            ativo: doc.data().Ativo,
            ibge: doc.data().ibge,
            uf: doc.data().uf


          };
          resolve(data);
        })
      })
      .catch(error => {
        const erro = {
          error,
          msg: error.code
        };
        reject(erro);
      });

  });
}


export function getCidadeByIBGE(ibge) {
  return new Promise(function (resolve, reject) {
    Libfirebase.collection('cidade')
      .where('ibge', '==', ibge)
      .where('Ativo', '==', true)
      .get()
      .then(async (snapShot) => {
        snapShot.forEach(async (doc) => {
          const data = {
            id: doc.id,
            cidade: doc.data().Cidade,
            ativo: doc.data().Ativo,
            ibge: doc.data().ibge,
            uf: doc.data().uf


          };
          resolve(data);
        })
      })
      .catch(error => {
        const erro = {
          error,
          msg: error.code
        };
        reject(erro);
      });

  });
}

export function getCidadesByUF(uf) {
  return new Promise(function (resolve, reject) {
    Libfirebase.collection('cidade')
      .where('uf', '==', uf)
      .where('Ativo', '==', true)
      .get()
      .then(async (snapShot) => {
        let list = snapShot.docs.map(doc => ({
          id: doc.id,
          cidade: doc.data().Cidade,
          ativo: doc.data().Ativo,
          ibge: doc.data().ibge,
          uf: doc.data().uf
        }));
        resolve(list);
      })
      .catch(error => {
        const erro = {
          error,
          msg: error.code
        };
        reject(erro);
      });

  });
}

export function getCidadesAtivo() {
  return new Promise(function (resolve, reject) {
    Libfirebase.collection('cidade')
      .where('Ativo', '==', true)
      .get()
      .then(async (snapShot) => {
        let list = snapShot.docs.sort((a, b) => {
          return removeAcentos(a.data().Cidade) > removeAcentos(b.data().Cidade) ? 1 : -1;
        })
          .map(doc => ({
            id: doc.id,
            cidade: doc.data().Cidade,
            ativo: doc.data().Ativo,
            ibge: doc.data().ibge,
            uf: doc.data().uf
          }));
        resolve(list);
      })
      .catch(error => {
        const erro = {
          error,
          msg: error.code
        };
        reject(erro);
      });

  });
}